// React
import React from "react";
// React
// CSS
import styles from "./Quiz.module.css";
// CSS
import { I_TechItemPart, _Option } from "../../../Models/interfaces";
import Swal from "sweetalert2";
import parse from "html-react-parser";

type QuizProps = {
  currDataIndex: number;
  teachData?: I_TechItemPart;
  createMarkup: (markup: string) => {
    __html: string;
  };
  questionAnswer: _Option;
  setQuestionAnswer: React.Dispatch<React.SetStateAction<_Option>>;
  setCurrDataIndex: React.Dispatch<React.SetStateAction<number>>;

  onVideoSelected: () => void;
};

const Quiz: React.FunctionComponent<QuizProps> = ({
  currDataIndex,
  teachData,
  createMarkup,
  questionAnswer,
  setQuestionAnswer,
  setCurrDataIndex,
  onVideoSelected,
}) => {
  return (
    <div
      className={`${styles.quizContainer} w-full pt-1 px-4 ${
        window.matchMedia("(display-mode: standalone)").matches ? "mt-2" : ""
      }`}
    >
      {teachData?.data[currDataIndex].question?.image_url === null ? (
        <span
          dangerouslySetInnerHTML={createMarkup(
            teachData?.data[currDataIndex].question?.title
          )}
          className={`text-sm `}
        ></span>
      ) : (
        <>
          <div className="text-sm">
            {parse(teachData?.data[currDataIndex].question?.title ?? "")}
          </div>
          <img
            src={
              teachData?.data[currDataIndex].question?.image_url.replace(
                /(http[^\s])/i,
                "https:"
              ).replace("::", ":") ?? ""
            }
            alt=""
          />
        </>
      )}
      {!teachData?.data[currDataIndex].question
        ? null
        : teachData?.data[currDataIndex].question?.options.map((item) => (
            <div
              className={`${styles.answerContainer} flex flex-row-reverse items-center justify-start w-full my-2 relative`}
              key={item.id}
              onClick={() => {
                if (!setQuestionAnswer) return;
                setQuestionAnswer((prevState) => {
                  if (prevState.id === item.id) {
                    return prevState;
                  }
                  return item;
                });
              }}
            >
              <input
                type="checkbox"
                onChange={() => {}}
                checked={item.id === questionAnswer.id}
                className={`${styles.customInput}`}
                style={{
                  width: "2",
                }}
              />
              {item.image_url === null ? (
                <div
                  style={{ direction: "rtl", marginRight: "3rem" }}
                  className="pr-2 text-xs text-right"
                >
                  {parse(item.title ?? "")}
                </div>
              ) : (
                <>
                  <img
                    src={item.image_url.replace(/(http[^\s])/i, "https:").replace("::", ":") ?? ""}
                    alt=""
                    className="justify-self-center h-10"
                    style={{
                      maxWidth: "calc(100% - 2.5rem)",
                      marginRight: "3rem",
                    }}
                  />
                </>
              )}
            </div>
          ))}
      <button
        onClick={() => {
          // submit Handling :)

          if (questionAnswer.id === 0) {
            Swal.fire({
              icon: "error",
              title: " لطفا یکی از گزینه ها را انتخاب کنید",
            });
            return;
          }

          Swal.fire({
            icon:
              String(
                teachData?.data[currDataIndex].question?.options.find(
                  (item) => item.is_correct
                )?.id
              ) === String(questionAnswer.id)
                ? "success"
                : "error",

            title:
              String(
                teachData?.data[currDataIndex].question?.options.find(
                  (item) => item.is_correct
                )?.id
              ) === String(questionAnswer.id)
                ? "جوابت درسته"
                : "اشتباه گفتی",

            // customClass: styles.rtl,
            showConfirmButton: true,
            showCancelButton: true,
            cancelButtonText: "مشاهده مجدد",
            confirmButtonText: "برو به قسمت بعدی",
          }).then(({ isConfirmed }) => {
            if (isConfirmed) {
              setCurrDataIndex((prevState) => {
                if (prevState === Number(teachData?.data.length) - 1) {
                  return prevState;
                }
                return prevState + 1;
              });
              onVideoSelected();
            } else {
              setCurrDataIndex((prevState) => {
                return prevState - 1;
              });
              onVideoSelected();
            }
          });
          // console.log(data);
        }}
        className={`${styles.answerSubmitterBtn}  rounded-lg py-2 w-full text-center text-sm text-white`}
      >
        ثبت پاسخ
      </button>
    </div>
  );
};

export default Quiz;
